export interface MentionsPlugin {
  trigger?: string;
  id?: string;
}

export const ELEMENT_MENTION = "mention";
